import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MoreVertical, Pencil, Trash2 } from "lucide-react";
import AWSFileViewer from "../AWSFileViewer";
import AddNewReferenceFileModal from "../AddNewReferenceFileModal";
import UpdateReferenceFileModal from "../UpdateReferenceFileModal";
import { toast } from "react-toastify";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const LabOpportunityDetals = ({owner}) => {
    const { id,university_name,dean_name,department_name } = useParams()
    const navigate = useNavigate()
    const [opportunityDetail,setOpportunityDetail] = useState()
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null)
    const [isOpen, setIsOpen] = useState(false);
    const [isAddModalOpen,setIsAddModalOpen]=useState(false)
    const [currentFile, setCurrentFile] = useState({ id: null, file: null })
    // Inside your component
    const dropdownRef = useRef(null)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownIndex(null)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [dropdownRef])

    const fetchOpportunityDetail=async()=>{
            try {
                const response=await axios.get(`${BASE_URL}/marketplace/university/lab-opportunity/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        })
        // console.log("The response is:",response)
           setOpportunityDetail(response?.data)
            } catch (error) {
                console.log("Error while getting lab opportunity details")
                toast.error(error.code)
            }
        }

    useEffect(()=>{
        if(!id) return;
        fetchOpportunityDetail()
    },[id])

     const deleteMain =async () => {
       const confirmed = window.confirm('Are you sure you want to delete this lab opportunity?');
     if (!confirmed) return; 
   try {
           
            const res = await axios.delete(`${BASE_URL}/marketplace/university/lab-opportunity/${id}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    'x-api-key': process.env.REACT_APP_X_API_KEY,
                },
            })
            // console.log("The res is:",res)
            if (res.status === 204 || res.status === 201) {
                alert('Lab opportunity deleted successfully!')
                navigate(owner === 'labhead' ? `/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/opportunities` : "/marketplace/independent_researcher/dashboard/mylabspaces")
            }
        } catch (error) {
            console.log("Error while deleting lab opportunity", error)
            toast.error(error.code)
        }
    };

    const handleFileDelete = async (id) => {
  // Ask for confirmation
  const confirmed = window.confirm('Are you sure you want to delete this file?');
  if (!confirmed) return; 
    try {
            const res = await axios.delete(`${BASE_URL}/marketplace/university/lab-opportunity/reference_files/${id}/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    'x-api-key': process.env.REACT_APP_X_API_KEY,
                },
            })
            // console.log("The res is:",res)
            if (res.status === 204 || res.status === 201) {
                alert('File deleted successfully!')
                fetchOpportunityDetail()
            }
        } catch (error) {
            console.log("Error while updating file", error)
            toast.error(error.code)
        }
};

  return (
    <div className="min-h-screen flex justify-center">
            <div className="max-w-5xl w-full bg-white rounded-2xl shadow-lg ">
                
                {/* Image + MAIN Edit/Delete */}
                <div className="relative h-[350px]">
                      <AWSFileViewer publication_data={opportunityDetail}/>
                    <div className="absolute top-4 right-4 flex gap-2">
                        <button
                            onClick={()=>navigate(owner === 'labhead' ? `/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/opportunities/edit/${opportunityDetail?.id}` : `/marketplace/independent_researcher/dashboard/mylabspaces/lab_opportunity/edit/${opportunityDetail?.id}`)}
                            className="px-4 py-2 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                        </button>
                        <button
                            onClick={deleteMain}
                            className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition-colors flex items-center gap-2"
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                            Delete
                        </button>
                    </div>
                </div>
                    {/* Content */}
                <div className="p-6 space-y-6">
                    {/* Header */}
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-2xl font-semibold text-gray-900">{opportunityDetail?.name}</h1>
                            <p className="text-sm text-gray-500 mt-0.5">Research Details</p>
                        </div>
                    </div>
                    {/* Description */}
                    {opportunityDetail?.summary && (
                        <div className="p-4 bg-gray-50 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                                <p className="text-sm font-semibold text-gray-700">Summary</p>
                            </div>
                            <p className="text-gray-600">{opportunityDetail?.summary}</p>
                        </div>
                    )}
                {opportunityDetail?.description && (
    <div className="p-4 bg-gray-50 rounded-xl">
        <div className="flex items-center gap-2 mb-2">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <p className="text-sm font-semibold text-gray-700">Description</p>
        </div>
        <div
            className="text-gray-600"
            dangerouslySetInnerHTML={{ __html: opportunityDetail?.description }}
        />
    </div>
)}

                    {/* Info Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                                    </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">Domain</p>
                            <p className="font-medium text-gray-900">{opportunityDetail?.domain}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                    </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">Maturity</p>
                            <p className="font-medium text-gray-900">{opportunityDetail?.maturity}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-xl">
                            <div className="flex items-center gap-2 mb-2">
                                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                    <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                    </svg>
                                </div>
                            </div>
                            <p className="text-xs text-gray-500 mb-1">Collaboration</p>
                            <p className="font-medium text-gray-900">{opportunityDetail?.collaboration}</p>
                        </div>
                    </div>
                    {/* Reference Files */}
                    <div className="border-t border-gray-100 pt-6">
                        <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                                    <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <div>
                                    <h2 className="text-lg font-semibold text-gray-900">Reference Files</h2>
                                    <p className="text-sm text-gray-500 mt-0.5">Attached documents and resources</p>
                                </div>
                            </div>
                            <button
                                onClick={()=> setIsAddModalOpen(true)}
                                className="px-4 py-2 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
                            >
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Add New Reference
                            </button>
                        </div>
                        {opportunityDetail?.reference_files?.length === 0 ? (
                            <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
                                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </div>
                                <h3 className="text-lg font-medium text-gray-700 mb-2">No reference files</h3>
                                <p className="text-sm text-gray-500">Add reference files to this research</p>
                            </div>
                        ) : (
                            <div className="space-y-3">
                                {opportunityDetail?.reference_files?.map((file) => (
                                    <div
                                        key={file.id}
                                        className="flex flex-col md:flex-row md:justify-between md:items-center bg-gray-50 p-4 rounded-xl gap-4"
                                    >
                                        <div className="flex items-center gap-3 w-full">
                                            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                                                <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                    />
                                                </svg>
                                            </div>
                                            <div className="flex-1 min-w-0 break-words">
                                                <a
                                                    href={file.file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="font-medium text-blue-600 underline hover:text-blue-800"
                                                >
                                                    {file.file.split("/").pop()} {/* Shows just the filename */}
                                                </a>
                                                <p className="text-xs text-gray-500 uppercase mt-0.5">
                                                    {file.publication_type}
                                                </p>
                                            </div>
                                            {/* Three vertical dots at the end */}
                                            <div className="relative flex-shrink-0 ml-2">
                                                <MoreVertical size={18} 
                                                onClick={() =>
                                                    setOpenDropdownIndex(openDropdownIndex === file.id ? null : file.id)
                                                } 
                                                className=" cursor-pointer" />
                                                {
                                                    openDropdownIndex === file.id && (
                                                        <div ref={dropdownRef} className="absolute top-9 right-0 bg-white border border-gray-300 rounded-lg flex flex-col min-w-[120px] z-[1000]">
                                                            <button
                                                                onClick={() => {
                                                                    setCurrentFile({ id: file.id, file: file.file })
                                                                    setIsOpen(true)
                                                                    setOpenDropdownIndex(null)
                                                                }
                                                                }
                                                                className="px-3 py-2 flex items-center gap-1.5 text-sm rounded-md hover:bg-gray-100 cursor-pointer transition-colors duration-200 ease-in-out"
                                                                title="Edit"
                                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                            >
                                                                <Pencil size={14} /> Edit
                                                            </button>
                                                            <button
                                                                onClick={()=>{
                                                                    handleFileDelete(file.id)
                                                                    setOpenDropdownIndex(null)
                                                                }}
                                                                className="px-3 py-2 flex items-center gap-1.5 text-sm rounded-md hover:bg-gray-100 cursor-pointer transition-colors duration-200 ease-in-out"
                                                                title="Delete"
                                                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <Trash2 size={14} /> Delete
                                                            </button>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>

                                ))}
                            </div>
                        )}
                    </div>
                </div>
    </div>
      <UpdateReferenceFileModal isOpen={isOpen} setIsOpen={setIsOpen} currentFile={currentFile.file} id={currentFile.id} fetchPublicationDetail={fetchOpportunityDetail} research_type="labopportunity" />
      <AddNewReferenceFileModal isAddModalOpen={isAddModalOpen} setIsAddModalOpen={setIsAddModalOpen} research_type="labopportunity" fetchPublicationDetail={fetchOpportunityDetail} id={id} />   
    </div>
  )
}

export default LabOpportunityDetals
